import * as APIRoutes from '@mm/api-routes';
import CompanyDashboardModel from '../model/CompanyDashboardModel';
import CompanyModel from '../model/CompanyModel';
import AuthenticatedController from './AuthenticatedController';
import { mapBEChatbotToFEChatbot } from './ChatbotController';

export type CreateCompanyEntity = Partial<CompanyModel> & {
  instachamp?: boolean;
};

export const mapBECompanyDataModelToFE = (
  model: Omit<CompanyModel, 'bots'> & { bots?: any[] },
) =>
  ({
    ...model,
    bots: model.bots && model.bots.map(mapBEChatbotToFEChatbot),
  } as CompanyModel);

export default class CompanyController extends AuthenticatedController {
  static async getAll(params?: string) {
    const queryParams = params ? `?${new URLSearchParams(params)}` : '';
    const response = await super.get(`${APIRoutes.COMPANIES}${queryParams}`);
    response.companies = response.companies.map(mapBECompanyDataModelToFE);
    return response as CompanyDashboardModel;
  }

  static postCompany(
    entity: CreateCompanyEntity,
  ): Promise<{ company: CompanyModel; errors: string[]; success: boolean }> {
    return super.post(APIRoutes.COMPANIES, entity);
  }

  static update(entity) {
    return super.put(APIRoutes.COMPANY(entity.id), entity);
  }

  static getById(entity: Partial<CompanyModel>, params?: string) {
    const queryParams = params ? `?${new URLSearchParams(params)}` : '';
    return super.get(`${APIRoutes.COMPANY(entity.id)}${queryParams}`);
  }

  static getCompanyBots(companyId) {
    const response = super.get(
      `${APIRoutes.COMPANIES}/${companyId}/bots_statistics`,
    );
    return {
      ...response,
      companyId,
    };
  }
}
